<template>
  <f7-page name="upcoming" class="articles">
    <f7-navbar title="Article Details" back-link="Back">
      <f7-nav-right>
        <f7-link href="/" class="menu-icon"
          ><i class="az-icon-home-house-interface-ui-website"></i
        ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-row>
      <div class="col-40 col-sm-0">
        <div class="left-az-logo">
          <img src="../assets/images/left-logo.png" alt="" />
        </div>
      </div>
      <div class="col-60 col-sm-100">
    <f7-block-title v-if="article.id">{{ article.title }}</f7-block-title>

    <f7-block v-if="article.id">
      <div
        :style="
          'background-size: cover; height: 40vw; color: #FFF; font-weight: bold; background-image:url(' +
          $root.siteURL +
          article.photo.replace('public', 'storage') +
          ')'
        "
        class="card-header align-items-flex-end"
      ></div>

      <p class="date">
        {{ article.created_at }} -
        <strong>{{ article.speciality.name }}</strong>
      </p>

      <div class="article-content" v-html="article.content"></div>
    </f7-block>
      </div>
    </f7-row>


  </f7-page>
</template>
<script>
export default {
  data() {
    return {
      article: {},
    };
  },
  mounted: function () {
    this.article = JSON.parse(sessionStorage.getItem("currentArticle"));
  },
};
</script>
<style scoped>
.menu-icon i::before {
  color: #870047;
  font-size: 35px;
}
</style>
